import React from "react";
import { Popconfirm } from "antd";
import { useFormContext } from "react-hook-form";
import { BookOpen, Trash } from "react-feather";
import PropTypes from "prop-types";
import { IoPencil } from "react-icons/io5";
import { hasPermission } from "core/Operations/checkPermission";

const DeleteController = ({
  isDisabled,
  id,
  handleUpdateAttendance,
  splitAttendanceDelete,
  addAttendanceHandler,
  permissions,
}) => {
  const { watch, setValue } = useFormContext();

  const hasDeletePermission = hasPermission(
    permissions,
    "Time & Attendance",
    "Time Tracking",
    "haveDelete"
  );
  const deleteHandler = (id) => {
    const attendance = watch("attendance");
    console.log("id", id);
    // const index = attendance.findIndex((a) => a.id === id);
    // console.log("index", index);
    if (id !== -1) {
      console.log(watch(`attendance[${id}]`));
      if (watch(`attendance[${id}].haveSplit`)) {
        splitAttendanceDelete(id);
      } else {
        setValue(`attendance[${id}].attendanceValue`, 0);
        setValue(`attendance[${id}].inTime`, "00:00:00");
        setValue(`attendance[${id}].outTime`, "00:00:00");
        setValue(`attendance[${id}].scheduleId`, 0);
        setValue(`attendance[${id}].projectCode`, "");
        setValue(`attendance[${id}].shiftId`, "");
        setValue(`attendance[${id}].waitingTime`, "00:00:00");
        setValue(`attendance[${id}].isApproved`, false);
        setValue(`attendance[${id}].wtnhEdit`, true);
        setValue(`attendance[${id}].supplierCompany`, "");
        setValue(`attendance[${id}].service`, "");
        setValue(`attendance[${id}].isReviewed`, false);
        setValue(`attendance[${id}].reviewDate`, "");
        setValue(`attendance[${id}].reviewBy`, "");
        setValue(`attendance[${id}].approvedDate`, "");
        setValue(`attendance[${id}].approvedBy`, "");
        setValue(`attendance[${id}].haveSplit`, false);
        setValue(`attendance[${id}].haveShift`, false);
        setValue(`attendance[${id}].wtrot`, "");
        setValue(`attendance[${id}].normalHours`, 0);
        setValue(`attendance[${id}].hasOutTime`, true);
        setValue(`attendance[${id}].isAlternateDayOff`, false);
        setValue(`attendance[${id}].isHalfDay`, false);
        setValue(`attendance[${id}].remarks`, "");
        handleUpdateAttendance(id);
      }
    } else {
      console.warn(`No attendance entry found for id: ${id}`);
    }
  };

  return (
    <Popconfirm
      title="Delete the attendance data?"
      description="Really want to dalete data for this date?"
      icon={<BookOpen className="me-2" />}
      onConfirm={() => deleteHandler(id)}
      onCancel={() => console.log("Cancel")}
      okText="Yes"
      cancelText="No"
    >
      <button
        type="button"
        className="btn btn-default btn-sm"
        // disabled={hasDeletePermission === true ? false : isDisabled}
        disabled={isDisabled}
      >
        <Trash />
      </button>
    </Popconfirm>
  );
};

DeleteController.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  id: PropTypes.number.isRequired,
  handleUpdateAttendance: PropTypes.func.isRequired,
  addAttendanceHandler: PropTypes.func.isRequired,
  splitAttendanceDelete: PropTypes.func.isRequired,
  permissions: PropTypes.array.isRequired,
};

export default React.memo(DeleteController);
